import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './indentGuides.css';
import { DynamicViewOverlay } from '../../view/dynamicViewOverlay.js';
import { Position } from '../../../common/core/position.js';
import { editorActiveIndentGuides, editorIndentGuides } from '../../../common/view/editorColorRegistry.js';
import { registerThemingParticipant } from '../../../../platform/theme/common/themeService.js';
export var IndentGuidesOverlay = /*#__PURE__*/function (_DynamicViewOverlay) {
  _inherits(IndentGuidesOverlay, _DynamicViewOverlay);

  var _super = _createSuper(IndentGuidesOverlay);

  function IndentGuidesOverlay(context) {
    var _this;

    _classCallCheck(this, IndentGuidesOverlay);

    _this = _super.call(this);
    _this._context = context;
    _this._primaryLineNumber = 0;
    var options = _this._context.configuration.options;
    var wrappingInfo = options.get(118
    /* wrappingInfo */
    );
    var fontInfo = options.get(36
    /* fontInfo */
    );
    _this._lineHeight = options.get(51
    /* lineHeight */
    );
    _this._spaceWidth = fontInfo.spaceWidth;
    _this._enabled = options.get(75
    /* renderIndentGuides */
    );
    _this._activeIndentEnabled = options.get(45
    /* highlightActiveIndentGuide */
    );
    _this._maxIndentLeft = wrappingInfo.wrappingColumn === -1 ? -1 : wrappingInfo.wrappingColumn * fontInfo.typicalHalfwidthCharacterWidth;
    _this._renderResult = null;

    _this._context.addEventHandler(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(IndentGuidesOverlay, [{
    key: "dispose",
    value: function dispose() {
      this._context.removeEventHandler(this);

      this._renderResult = null;

      _get(_getPrototypeOf(IndentGuidesOverlay.prototype), "dispose", this).call(this);
    } // --- begin event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      var wrappingInfo = options.get(118
      /* wrappingInfo */
      );
      var fontInfo = options.get(36
      /* fontInfo */
      );
      this._lineHeight = options.get(51
      /* lineHeight */
      );
      this._spaceWidth = fontInfo.spaceWidth;
      this._enabled = options.get(75
      /* renderIndentGuides */
      );
      this._activeIndentEnabled = options.get(45
      /* highlightActiveIndentGuide */
      );
      this._maxIndentLeft = wrappingInfo.wrappingColumn === -1 ? -1 : wrappingInfo.wrappingColumn * fontInfo.typicalHalfwidthCharacterWidth;
      return true;
    }
  }, {
    key: "onCursorStateChanged",
    value: function onCursorStateChanged(e) {
      var selection = e.selections[0];
      var newPrimaryLineNumber = selection.isEmpty() ? selection.positionLineNumber : 0;

      if (this._primaryLineNumber !== newPrimaryLineNumber) {
        this._primaryLineNumber = newPrimaryLineNumber;
        return true;
      }

      return false;
    }
  }, {
    key: "onDecorationsChanged",
    value: function onDecorationsChanged(e) {
      // true for inline decorations
      return true;
    }
  }, {
    key: "onFlushed",
    value: function onFlushed(e) {
      return true;
    }
  }, {
    key: "onLinesChanged",
    value: function onLinesChanged(e) {
      return true;
    }
  }, {
    key: "onLinesDeleted",
    value: function onLinesDeleted(e) {
      return true;
    }
  }, {
    key: "onLinesInserted",
    value: function onLinesInserted(e) {
      return true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return e.scrollTopChanged; // || e.scrollWidthChanged;
    }
  }, {
    key: "onZonesChanged",
    value: function onZonesChanged(e) {
      return true;
    }
  }, {
    key: "onLanguageConfigurationChanged",
    value: function onLanguageConfigurationChanged(e) {
      return true;
    } // --- end event handlers

  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {
      if (!this._enabled) {
        this._renderResult = null;
        return;
      }

      var visibleStartLineNumber = ctx.visibleRange.startLineNumber;
      var visibleEndLineNumber = ctx.visibleRange.endLineNumber;

      var _this$_context$model$ = this._context.model.getTextModelOptions(),
          indentSize = _this$_context$model$.indentSize;

      var indentWidth = indentSize * this._spaceWidth;
      var scrollWidth = ctx.scrollWidth;
      var lineHeight = this._lineHeight;

      var indents = this._context.model.getLinesIndentGuides(visibleStartLineNumber, visibleEndLineNumber);

      var activeIndentStartLineNumber = 0;
      var activeIndentEndLineNumber = 0;
      var activeIndentLevel = 0;

      if (this._activeIndentEnabled && this._primaryLineNumber) {
        var activeIndentInfo = this._context.model.getActiveIndentGuide(this._primaryLineNumber, visibleStartLineNumber, visibleEndLineNumber);

        activeIndentStartLineNumber = activeIndentInfo.startLineNumber;
        activeIndentEndLineNumber = activeIndentInfo.endLineNumber;
        activeIndentLevel = activeIndentInfo.indent;
      }

      var output = [];

      for (var lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
        var containsActiveIndentGuide = activeIndentStartLineNumber <= lineNumber && lineNumber <= activeIndentEndLineNumber;
        var lineIndex = lineNumber - visibleStartLineNumber;
        var indent = indents[lineIndex];
        var result = '';

        if (indent >= 1) {
          var leftMostVisiblePosition = ctx.visibleRangeForPosition(new Position(lineNumber, 1));
          var left = leftMostVisiblePosition ? leftMostVisiblePosition.left : 0;

          for (var i = 1; i <= indent; i++) {
            var className = containsActiveIndentGuide && i === activeIndentLevel ? 'cigra' : 'cigr';
            result += "<div class=\"".concat(className, "\" style=\"left:").concat(left, "px;height:").concat(lineHeight, "px;width:").concat(indentWidth, "px\"></div>");
            left += indentWidth;

            if (left > scrollWidth || this._maxIndentLeft > 0 && left > this._maxIndentLeft) {
              break;
            }
          }
        }

        output[lineIndex] = result;
      }

      this._renderResult = output;
    }
  }, {
    key: "render",
    value: function render(startLineNumber, lineNumber) {
      if (!this._renderResult) {
        return '';
      }

      var lineIndex = lineNumber - startLineNumber;

      if (lineIndex < 0 || lineIndex >= this._renderResult.length) {
        return '';
      }

      return this._renderResult[lineIndex];
    }
  }]);

  return IndentGuidesOverlay;
}(DynamicViewOverlay);
registerThemingParticipant(function (theme, collector) {
  var editorIndentGuidesColor = theme.getColor(editorIndentGuides);

  if (editorIndentGuidesColor) {
    collector.addRule(".monaco-editor .lines-content .cigr { box-shadow: 1px 0 0 0 ".concat(editorIndentGuidesColor, " inset; }"));
  }

  var editorActiveIndentGuidesColor = theme.getColor(editorActiveIndentGuides) || editorIndentGuidesColor;

  if (editorActiveIndentGuidesColor) {
    collector.addRule(".monaco-editor .lines-content .cigra { box-shadow: 1px 0 0 0 ".concat(editorActiveIndentGuidesColor, " inset; }"));
  }
});